import { render, staticRenderFns } from "./search_results_summary.vue?vue&type=template&id=0e8cd74c&"
import script from "./search_results_summary.vue?vue&type=script&lang=js&"
export * from "./search_results_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports